import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { Params } from '@angular/router';
import { SharedModule } from '../../../shared.module';
import { WidgetNumberDisplayComponent } from '../widget-number-display/widget-number-display.component';

@Component({
  selector: 'app-widget-services-display',
  styleUrls: ['./widget-services-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [WidgetNumberDisplayComponent, SharedModule],
  template: `
    <app-widget-number-display
      class="widget-services-display dimensions-stretch"
      [status]="'ACTIVE'"
      [number]="serviceCount"
      [label]="serviceCount || 0 | pluralize: 'Service'"
      [hyperlink]="hyperlink"
      [queryParams]="queryParams"
      [ctaText]="'View Services'"
      [navigateOnClick]="navigateOnClick"
      [loading]="loading"
    >
      <div titlePrefixIcon class="widget-element-icon custom-icon">
        <i class="material-icons">directions_run</i>
      </div>

      <mat-icon class="services-display-icon">directions_run</mat-icon>

      <div class="service_icon">
        <div class="total-locations">
          Spanning {{ locationCount }}
          {{ locationCount | pluralize: 'location' }}
        </div>
      </div>
    </app-widget-number-display>
  `,
})
export class WidgetServicesDisplayComponent {
  @Input() queryParams: Params | null = null;

  @Input() navigateOnClick: boolean = false;

  @Input() hyperlink: string | null = null;

  @Input() locationCount: number = 0;

  @Input() serviceCount: number = 0;

  @Input() loading: boolean = true;
}
